import { render, staticRenderFns } from "./Botabib.vue?vue&type=template&id=6ee53866&"
import script from "./Botabib.vue?vue&type=script&lang=js&"
export * from "./Botabib.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports